import VueSkeletor from 'vue-skeletor'
import 'vue-skeletor/dist/vue-skeletor.css';

export default VueSkeletor
